import indexSouthern from '../../layout/indexSouthern.vue';
const homeRouter = {
	path: '/',
	component: indexSouthern,
	redirect: '/',
	name: 'chinese',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		//南方研究主页

		{
			path: '/cn',
			component: () => import('@/pages/chinese/views/southernStudies'),
			name: 'cn',
		},

		//南方研究文章详情页
		{
			path: '/detailsSouthern',
			component: () =>
				import('@/pages/chinese/views/detail/detailsSouthern'),
			name: 'detailsSouthern',
		},
		//南方研究中心报告列表页
		{
			path: '/cn/reportList',
			component: () =>
				import('@/pages/chinese/views/southernStudies/reportList'),
			name: 'reportListCn',
		},
		//南方研究中心近期活动列表页（与英文共用同一组件）
		{
			path: '/cn/activityList',
			component: () =>
				import('@/pages/chinese/views/southernStudies/activityList'),
			name: 'activityListCn',
		},
	],
};

export default homeRouter;
